import { Routes } from 'react-router-dom'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import mapRouterHelper from '../../utils/MapRouterHelper'
import DocumentTypeRouters from './modules/document-type/DocumentType.Routers'
import DocumentIssuingDisciplineRouters from './modules/document-issuing-discipline/DocumentIssuingDiscipline.Routers'
import DocumentDetailRouters from './modules/document-detail/DocumentDetailRouters'
import DocumentRouters from './modules/document/DocumentRouters'
import { DMS_SHORT_PREFIX_URL } from './constants/config.dms'
import DocumentPermissionActionRouters from './modules/document-permission-action/DocumentPermissionAction.Routers'
import DocumentPermissionRoleRouters from './modules/document-permission-role/DocumentPermissionRole.Routers'

const DMSRouters: AppRouterItem[] = [
  {
    path: `${DMS_SHORT_PREFIX_URL}/*`,
    element: (
      <Routes>
        {mapRouterHelper(DocumentTypeRouters)}
        {mapRouterHelper(DocumentIssuingDisciplineRouters)}
        {mapRouterHelper(DocumentPermissionActionRouters)}
        {mapRouterHelper(DocumentPermissionRoleRouters)}
        {mapRouterHelper(DocumentDetailRouters)}
        {mapRouterHelper(DocumentRouters)}
      </Routes>
    ),
  },
]

export default DMSRouters
